import type React from 'react';

/**
 * True when a click on a link must be left to the browser instead of being
 * turned into a client-side navigation: modifier-clicks (open in a new
 * tab/window, download), non-primary buttons, anchors aimed at another frame,
 * and events something else already handled.
 *
 * Any handler that pairs a real `href` with `preventDefault()` + `navigate()`
 * has to bail out on these, otherwise cmd/ctrl+click silently navigates the
 * current tab rather than opening a new one.
 */
export function isBrowserHandledLinkClick(event: React.MouseEvent<HTMLElement>): boolean {
  const target = (event.currentTarget as HTMLAnchorElement).target;

  return (
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey ||
    Boolean(target && target !== '_self')
  );
}
